import {Component, EventEmitter, OnInit, Output, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {AuthService} from '../../core/auth/auth.service';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SettingsService} from '../../core/settings/settings.service';
import {Observable} from 'rxjs/Rx';
import 'rxjs/observable/forkJoin';
import {AccountsService} from '../../core/accounts/accounts.service';
import {MapService} from '../../core/map/map.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  @Output() close = new EventEmitter();

  @Output() openPlanModal = new EventEmitter();

  profile: any;

  modalRef: BsModalRef;

  locationForm: FormGroup;

  changePasswordForm: FormGroup;

  resetting = false;

  resetForm: FormGroup;

  passphrase = 'Delete All Accounts';

  uploadActive: boolean;

  changingPassword: boolean;

  changePasswordSuccess: string;

  changePasswordError: string;

  constructor(private router: Router,
              private fb: FormBuilder,
              private mapService: MapService,
              private accountsService: AccountsService,
              private settingsService: SettingsService,
              private modalService: BsModalService,
              private auth: AuthService) { }

  ngOnInit() {
    this.profile = this.auth.getProfile();

    this.locationForm = this.fb.group({
      address: ['', Validators.required],
      lat: ['', Validators.required],
      lng: ['', Validators.required]
    });

    this.changePasswordForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required]
    });

    this.resetForm = this.fb.group({
      passphrase: ['', Validators.required]
    });

    this.settingsService.get().subscribe((data: any) => {
      if (!data || !data.center) {
        return;
      }

      this.locationForm.get('address').setValue(data.center.address);

      if (data.center && data.center.coords && data.center.coords.length) {
        this.mapService.center(data.center.coords[1], data.center.coords[0]);
      }

    });
  }

  resetEnabled() {
    return this.resetForm.valid && this.passphrase.toUpperCase() === this.resetForm.controls['passphrase'].value.toString().toUpperCase();
  }

  reset() {
    this.resetting = true;
    this.auth.reset()
      .subscribe(() => {
        window.location.reload();
      }, (err) => {
        this.resetting = false;
        alert(err.error.message || 'An error occurred');
      });
  }

  changePassword(data) {
    this.changePasswordSuccess = '';
    this.changePasswordError = '';
    this.changingPassword = true;
    this.auth.changePassword(data)
      .subscribe(() => {
        this.changingPassword = false;
        this.changePasswordSuccess = 'Password successfully changed';
      }, (err: any) => {
        this.changingPassword = false;
        this.changePasswordError = err.error.message || 'An error occurred';
      });
  }

  openModal(e, template: TemplateRef<any>, options?) {
    this.modalRef = this.modalService.show(template, options ||{ class: 'modal-lg ' });
    e.preventDefault();
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  isAdmin() {
    return this.auth.isAdmin();
  }

  onUploadAccounts(accountRows) {
    const accounts = accountRows.map(ar => ({
      name: ar.Name,
      address: ar.Address,
      phone: ar.Phone,
      email: ar.Email,
      website: ar.Website
    }));

    this.uploadActive = true;

    Observable.forkJoin(accounts.filter(a => a.address).map((a, i) => this.findPlace(a, i))).subscribe(accountsWithPlace => {
      this.accountsService.bulkCreate(accountsWithPlace.filter(a => a))
        .subscribe(() => {
          this.uploadActive = false;
          this.modalRef.hide();
        });
    });
  }

  onSetPlace(address) {
    this.locationForm.controls['address'].setValue(address.formatted_address);
    this.locationForm.controls['lat'].setValue(address.geometry.location.lat());
    this.locationForm.controls['lng'].setValue(address.geometry.location.lng());
  }

  setLocation() {
    this.settingsService.edit({
      center: { address: this.locationForm.get('address').value, coords: [this.locationForm.get('lng').value, this.locationForm.get('lat').value]}})
      .subscribe(() => {});
  }

  findPlace(account, index) {
    return new Observable((observer) => {
      const geocoder = new google.maps.Geocoder;

      setTimeout(() => {
        geocoder.geocode({ address: account.address, componentRestrictions: { country: 'US'} }, (results, status) => {
          if (results && results.length) {
            const place = results[0];
            account.placeId = place.place_id;
            account.coords = [place.geometry.location.lng(), place.geometry.location.lat()];

            this.mapService.placesSearchService.getDetails({placeId: place.place_id, fields: ['opening_hours']}, (result, st) => {
              if (result && result.opening_hours) {
                account.notes = result.opening_hours.weekday_text.join('\n');
              }
              observer.next(account);
              observer.complete();
            });
          } else {
            observer.next(null);
            observer.complete();
          }
        });
      }, 1000 * index);
    });
  }

  getPlan() {
    return this.auth.getProfile().plan;
  }

  isTrialPlan() {
    return this.auth.isTrialPlan();
  }

  changePlan() {
    this.openPlanModal.next();
  }

}



// WEBPACK FOOTER //
// ./client/app/components/settings/settings.component.ts